import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const handleLinkClick = (type: 'privacy' | 'terms') => {
    // In production, these would link to actual policy pages
    alert(`Redirigiendo a ${type === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}...`);
  };
  return <footer className="w-full bg-white border-t border-[#C7E0E7]/20 py-8 px-4" data-id="element-27">
      <div className="max-w-6xl mx-auto" data-id="element-28">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-29">
          {/* Brand */}
          <div className="text-center md:text-left" data-id="element-30">
            <h3 className="text-xl font-bold text-[#C7E0E7]" data-id="element-31">CALMA EN CASA</h3>
            <p className="text-sm text-[#5C5C5C] mt-1" data-id="element-32">
              © {currentYear} Todos los derechos reservados
            </p>
          </div>

          {/* Links */}
          <div className="flex gap-6" data-id="element-33">
            <button onClick={() => handleLinkClick('privacy')} className="text-[#5C5C5C] hover:text-[#C7E0E7] transition-colors duration-200 text-sm font-medium focus:outline-none focus:underline" aria-label="Ver Política de Privacidad" data-id="element-34">
              Política de Privacidad
            </button>
            <button onClick={() => handleLinkClick('terms')} className="text-[#5C5C5C] hover:text-[#C7E0E7] transition-colors duration-200 text-sm font-medium focus:outline-none focus:underline" aria-label="Ver Términos y Condiciones" data-id="element-35">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </div>
    </footer>;
}